import React, { useState } from "react";
import "./Marketing.css";

const CreatePost = () => {
  const [form, setForm] = useState({
    topic: "",
    platform: "LinkedIn",
    postType: "Technical",
    audience: "",
    instruction: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="marketing-page">
      {/* HEADER */}
      <div className="marketing-header">
        <div>
          <div className="marketing-eyebrow">
            BUSINESS DEVELOPMENT / MARKETING / CREATE POST
          </div>

          <h1>✨ AI Content Studio</h1>

          <p>Give your marketing brief and let AI prepare the first draft.</p>
        </div>
      </div>

      <div className="ai-studio-layout">
        {/* LEFT SIDE */}
        <div className="ai-studio-card">
          <div className="studio-card-header">
            <div>
              <h2>Create AI Post</h2>
              <p>Enter the basic details for your marketing content.</p>
            </div>

            <span className="ai-badge">✦ AI ASSISTED</span>
          </div>

          <div className="studio-form">
            <div className="studio-field">
              <label>Topic / Occasion</label>

              <input
                type="text"
                name="topic"
                value={form.topic}
                onChange={handleChange}
                placeholder="Example: BIM Coordination Benefits"
              />
            </div>

            <div className="studio-form-row">
              <div className="studio-field">
                <label>Platform</label>

                <select
                  name="platform"
                  value={form.platform}
                  onChange={handleChange}
                >
                  <option value="LinkedIn">LinkedIn</option>
                  <option value="Instagram">Instagram</option>
                  <option value="Facebook">Facebook</option>
                </select>
              </div>

              <div className="studio-field">
                <label>Post Type</label>

                <select
                  name="postType"
                  value={form.postType}
                  onChange={handleChange}
                >
                  <option value="Technical">Technical</option>
                  <option value="Project">Project</option>
                  <option value="Festival">Festival</option>
                  <option value="Team">Team</option>
                  <option value="Educational">Educational</option>
                </select>
              </div>
            </div>

            <div className="studio-field">
              <label>Target Audience</label>

              <input
                type="text"
                name="audience"
                value={form.audience}
                onChange={handleChange}
                placeholder="Example: Architects, Developers, Project Managers"
              />
            </div>

            <div className="studio-field">
              <label>Additional Instructions</label>

              <textarea
                name="instruction"
                value={form.instruction}
                onChange={handleChange}
                rows="5"
                placeholder="Example: Keep the post professional, informative and suitable for LinkedIn."
              />
            </div>

            <button type="button" className="generate-ai-btn">
              ✨ Generate AI Post
            </button>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="ai-preview-card">
          <div className="preview-header">
            <div>
              <h2>Creative Preview</h2>
              <p>Your AI-generated post will appear here.</p>
            </div>

            <span className="draft-status">DRAFT</span>
          </div>

          <div className="empty-preview">
            <div className="empty-preview-icon">✨</div>

            <h3>Ready to create</h3>

            <p>Enter your post details and click Generate AI Post.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePost;
